import React, { Component } from 'react';
import classNames from 'classnames';

import SettingsTab from '../tab';

import Notification from '../../../../../../common/react/components/notification.js';

import StripePayment from '../sections/stripe-payment';
import EdlioPayPayment from '../sections/edlio-pay-payment';

export default class PaymentTab extends SettingsTab {
	constructor (props) {
		super(props);

		this.stripeFeatureActive = window.edlio.stripePayFeatureActive;
		this.edlioPayActive = window.edlio.edlioPayActive;
	}

	handleToggle(propertyName, val) {
		return (s) => {
			this.updateSetting(propertyName, val);
		}
	}

    render() {
    	if (this.props.isError) {
			this.props.isError.forEach(function(el) {
				el.style.boxShadow = "inset 0 0 0 2px #df7934";
			});
    	}

		let classes = classNames({
			'hidden': !this.props.selected
		}, 'payment')

		let data = {
			type: "alert",
			message: {
				headline: this.props.localization.substitute('Please fill out all required fields')
			}
		}

		return (
			<section className={classes}>
				<div className='left column'>
					{
						this.props.isError
						&&
						<Notification
							data={data}
						/>
					}
					{
						this.stripeFeatureActive && !this.props.formData.usesPay
						&&
						<StripePayment
						    localization={this.props.localization}
						    formData={this.props.formData}
						    updateCallback={this.updateSetting}
						/>
					}
					{
						this.edlioPayActive && this.props.formData.usesPay
						&&
						<EdlioPayPayment
						    localization={this.props.localization}
						    formData={this.props.formData}
						    updateCallback={this.updateSetting}
						/>
					}
				</div>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/tabs/payment.js